export default __webpack_public_path__ + "img/tab4s-e255d395.png";